/* eslint-disable no-console */
import _ from 'lodash';
import { useCallback } from 'react';
import { getErrorMessage } from '../../../utils/errorHandler';
import Logger from '../../../utils/Logger';
import { carouselActions, recoAnalytics } from '../../../utils/recoAnalytics';
import { getVariant } from '../../../utils/variant';
import { getTenantValue } from './constants';

export const useBuyTogetherHandler = ({ product, buytogether, appCtx, cart }) => {
  const slotsConfig = _.get(appCtx, 'siteConfig.textDictionary.PDP_SLOTS', 'PDP-HRT-1,PDP-HRT-2,PDP-BT-1');
  const slotsMap = slotsConfig.split(',').map((s) => s);
  const buyTogetherSlot = _.get(slotsMap, '[2]', '');
  const widgetName = buytogether?.widgetName?.split(' ').join('_') || 'Buy_Together';

  const handleAddToCart = useCallback(() => {
    if (!product || !buytogether?.data?.length) return;

    appCtx.setBusy(true);
    const currentVariantId = _.get(product, 'currentVariant');
    const variants = _.get(product, 'variants');
    const currentVariant = getVariant(variants, currentVariantId);
    const variantOfferingId = _.get(currentVariant, 'offerings[0].offeringId', '');

    const productToAdd = buytogether.data
      .filter((bundle) => bundle.isSelected)
      .map(({ id, offeringId, quantity }) => ({
        skuId: id,
        quantity,
        offeringId,
      }));

    cart
      .addProduct({
        appCtx,
        products: _.unionBy(
          [
            {
              skuId: currentVariantId,
              quantity: 1,
              offeringId: variantOfferingId,
            },
          ],
          productToAdd,
          'skuId'
        ),
        bundledProductOrigin: 'CTA',
        product,
      })
      .then((res) => {
        if (res && res.length) {
          const errorMessage = getErrorMessage(res, appCtx.siteConfig);
          Logger.error(`Failed addToCart for BuyTogether: ${errorMessage}`);
          return;
        }
        const { variantIds, variantIndexes } = [
          {
            isSelected: true,
            id: currentVariantId,
          },
          ...buytogether.data,
        ].reduce(
          (acc, variant, index) => {
            if (!variant.isSelected) {
              return acc;
            }
            acc.variantIds.push(variant.id);
            acc.variantIndexes.push(index + 1);
            return acc;
          },
          {
            variantIds: [],
            variantIndexes: [],
          }
        );
        const valueDelimiter = '-';
        recoAnalytics.click({
          carouselKey: 'CR_RecomendationCarousel',
          siteName: getTenantValue(appCtx?.store, appCtx?.regionCode),
          action: carouselActions.addToCart,
          carouselName: widgetName,
          pageName: product.currentVariant,
          skuId: variantIds.join(valueDelimiter),
          podPositionInCarousel: variantIndexes.join(valueDelimiter),
          lengthPodsInCarousel: buytogether.data.length,
          slotId: buyTogetherSlot,
        });
      })
      .catch((e) => {
        Logger.error(`Failed addToCart for BuyTogether: ${e}`);
      })
      .finally(() => {
        appCtx.setBusy(false);
      });
  }, [product, buytogether, appCtx, cart]);

  const updateAnalyticsClick = (skuId, index) => {
    recoAnalytics.click({
      carouselKey: 'CR_RecomendationCarousel',
      siteName: getTenantValue(appCtx?.store, appCtx?.regionCode),
      action: carouselActions.clickToRate,
      carouselName: widgetName,
      pageName: product.currentVariant,
      skuId,
      podPositionInCarousel: index,
      lengthPodsInCarousel: buytogether.data.length,
      slotId: buyTogetherSlot,
    });
  };

  const getImpressionAnalytics = (viewedVariant) => {
    recoAnalytics.impression({
      carouselName: `BT_${widgetName}`,
      skusViewed: [viewedVariant.id],
    });
  };

  return {
    handleAddToCart,
    updateAnalyticsClick,
    getImpressionAnalytics,
  };
};
